import { Routes, Route } from "react-router-dom";
import { MapComponent } from "./";
import "../App.css";

export { MapLayout };

function MapLayout() {
  return (
    <div className="p-4">
      <div className="container">
        <div className="App">
          <Routes>
            <Route index element={<MapComponent />} />
            {/* <Route path="add" element={<AddEdit />} />
                        <Route path="edit/:id" element={<AddEdit />} /> */}
          </Routes>
        </div>
      </div>
    </div>
  );
}
